import React, { useState } from 'react';
import { Typography, Box, Button, Snackbar, IconButton } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const ContactInfo = () => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');

  const contactInfo = {
    email: 'contacto@liderdist.com',
    phone: '1552218205'
  };

  const whatsappLink = `https://wa.me/549${contactInfo.phone}`;
  const emailLink = `mailto:${contactInfo.email}`;

  const handleCopy = (text, type) => {
    navigator.clipboard.writeText(text);
    setSnackbarMessage(`${type} copiado al portapapeles`);
    setSnackbarOpen(true);
  };

  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center',
      gap: 2,
      my: 1 
    }}>

      <Box sx={{ 
        display: 'flex', 
        gap: 2,
        flexWrap: 'wrap',
        justifyContent: 'center' 
      }}>
        <Box sx={{ position: 'relative' }}>
          <Button
            startIcon={<EmailIcon />}
            href={emailLink}
            variant="outlined"
            size="small"
            sx={{ color: '#666' }}
          >
            {contactInfo.email}
          </Button>
          <IconButton 
            size="small" 
            onClick={() => handleCopy(contactInfo.email, 'Email')}
            sx={{ 
              position: 'absolute',
              top: -10,
              right: -10,
              padding: '4px',
              backgroundColor: 'white',
              boxShadow: 1,
              '& .MuiSvgIcon-root': {
                fontSize: '0.875rem'
              }
            }}
          >
            <ContentCopyIcon />
          </IconButton>
        </Box>

        <Box sx={{ position: 'relative' }}>
          <Button
            startIcon={<WhatsAppIcon />}
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            variant="contained"
            size="small"
            sx={{
              backgroundColor: '#25D366',
              '&:hover': {
                backgroundColor: '#128C7E'
              }
            }}
          >
            WhatsApp
          </Button>
          <IconButton 
            size="small" 
            onClick={() => handleCopy(contactInfo.phone, 'Número')}
            sx={{ 
              position: 'absolute',
              top: -10,
              right: -10,
              padding: '4px',
              backgroundColor: 'white',
              boxShadow: 1,
              '& .MuiSvgIcon-root': {
                fontSize: '0.875rem'
              }
            }}
          >
            <ContentCopyIcon />
          </IconButton>
        </Box>
      </Box>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />
    </Box>
  );
};

export default ContactInfo; 